







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export interface PrefillReviewItem {
  label?: string;
  value: string;
  recorded_at?: string;
  [key: string]: any;
}

/**
 * Review checklist untuk field prefill bernilai list (`*_list` paths).
 * Data list TIDAK pernah di-merge otomatis ke form — petugas mencentang
 * item relevan lalu menekan Terapkan; host component menerima event
 * `apply(selectedItems)` dan menulisnya ke form state sendiri.
 */
@Component
export default class PrefillReviewList extends Vue {
  @Prop({ default: "" }) title!: string;
  @Prop({ default: () => [] }) items!: PrefillReviewItem[];
  @Prop({ default: false }) disabled!: boolean;

  selectedIdx: number[] = [];
  dismissed = false;

  @Watch("items")
  onItemsChanged() {
    this.selectedIdx = [];
    this.dismissed = false;
  }

  apply() {
    const selected = (this.items || []).filter((_, i) =>
      this.selectedIdx.indexOf(i) !== -1
    );
    if (selected.length === 0) return;
    this.$emit("apply", selected);
    // Setelah diterapkan, reset centang agar tidak dobel-apply.
    this.selectedIdx = [];
  }

  dismiss() {
    this.dismissed = true;
    this.$emit("dismiss");
  }
}
